import styled from 'styled-components/macro'
import { ThemedText } from 'theme'

// import ThemeToggle from 'theme/components/ThemeToggle'
// import ThemeToggle from 'theme/components/ThemeToggle'
import { SlideOutMenu } from './SlideOutMenu'
import { SmallBalanceToggle } from './SmallBalanceToggle'

const SectionTitle = styled(ThemedText.SubHeader)`
  color: ${({ theme }) => theme.textSecondary};
  padding-bottom: 24px;
`

// const ThemeToggleContainer = styled.div`
//   margin: 0 0 6px;
// `

const BalanceToggleContainer = styled.div`
  padding: 16px 0;
  margin-bottom: 26px;
`

export default function SettingsMenu({ onClose }: { onClose: () => void }) {
  // const isWalletPage = pathname.includes('/wallet')

  return (
    <SlideOutMenu title={<>Settings</>} onClose={onClose}>
      <SectionTitle>
        <>Preferences</>
      </SectionTitle>
      {/* <ThemeToggleContainer>
        <ThemeToggle disabled={isWalletPage} />
      </ThemeToggleContainer> */}
      <BalanceToggleContainer>
        <SmallBalanceToggle />
      </BalanceToggleContainer>
    </SlideOutMenu>
  )
}
